<script setup>
import {computed, inject} from 'vue';
import {router, usePage} from '@inertiajs/vue3';
import {event} from "vue-gtag";
import PrimaryLink from "@/Components/PrimaryLink.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import {productAsAnalyticItem} from "@/mixins";

const route = inject('route');
const props = defineProps({
    product: Object,
});
const productId = computed(() => props.product.productId);
const favorites = computed(() => usePage().props.favorites);
const designWall = computed(() => usePage().props.designWall);

function addToFavorites(productId) {
    router.patch(route('favorites.patch'), {
        productId: productId,
    }, {
        preserveScroll: true,
        preserveState: true,
        onSuccess: () => {
            event("add_to_wishlist", {
                currency: "USD",
                value: props.product.price / 100,
                items: [productAsAnalyticItem(props.product, 0)],
            });
        },
    });
}

function addToDesignWall(productId) {
    router.patch(route('design-wall.patch'), {
        productId: productId,
    }, {
        preserveScroll: true,
        preserveState: true,
    });
}

</script>
<template>
    <div class="flex flex-col items-center justify-center space-x-1 flex-wrap">
        <PrimaryLink v-if="favorites.products[productId]"
                     class="flex-1"
                     :inverted="true"
                     :href="route('products.favorites')">
            View favorites
        </PrimaryLink>
        <PrimaryButton v-else
                       class="flex-1"
                       :inverted="true"
                       @click="addToFavorites(productId)">
            Add to favorites
        </PrimaryButton>
        <template v-if="product.designWall">
            <PrimaryLink v-if="designWall.products[productId]"
                         class="flex-1"
                         :inverted="true"
                         :href="route('products.design-wall')">
                View design wall
            </PrimaryLink>
            <PrimaryButton v-else
                           class="flex-1"
                           :inverted="true"
                           @click="addToDesignWall(productId)">
                Add to design wall
            </PrimaryButton>
        </template>
    </div>
</template>
